/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import SupportContactSectionDumb from './SupportContactSectionDumb';
import { resetContactSupport } from 'src/shared/app/authentication/action/support/supportContactActions';
import { isSupportContacted } from 'src/shared/app/authentication/selector/support/appContactSelector';
import withMount from 'src/shared/app/base/component/hoc/withMount';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State): Object => ({
  isSupportContacted: isSupportContacted(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => ({
  ...stateProps,
  handleMount() {
    dispatch(resetContactSupport());
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(SupportContactSectionDumb);
